module.exports = __webpack_public_path__ + "img/important.bebd16d9.svg";